interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

const SearchBar = ({ value, onChange }: SearchBarProps) => {
  return (
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-4 sm:pl-5 flex items-center pointer-events-none">
        <i className="ri-search-line text-gray-400 text-lg sm:text-xl"></i>
      </div>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search events by name, description, or location..."
        className="w-full pl-12 sm:pl-14 pr-4 sm:pr-6 py-3.5 sm:py-5 bg-white border-2 border-white/20 rounded-xl sm:rounded-2xl text-sm sm:text-base text-gray-900 placeholder-gray-400 focus:outline-none focus:border-white focus:ring-4 focus:ring-white/30 transition-all shadow-lg"
      />
    </div>
  );
};

export default SearchBar;
